import { NoOptionsMessage } from '@/components/select';
import { SelectClearIndicator } from '@/components/select/SelectClearIndicator';
import Select from 'react-select';
import { KSelectStylesConfig } from '@/ui-library/design-system/constants/KSelect.styles';
import { CustomOptions } from '../../organisms/KFields/CustomOptions';

export const KSelect = ({
  variant = 'default',
  customStyles = {},
  customComponents = {},
  ...restProps
}) => {
  const styles = KSelectStylesConfig({
    variant,
    customStyles,
  });

  return (
    <Select
      styles={styles}
      components={{
        IndicatorSeparator: () => null,
        Option: CustomOptions,
        NoOptionsMessage: NoOptionsMessage,
        ClearIndicator: SelectClearIndicator,
        ...customComponents,
      }}
      isSearchable={restProps.isSearchable !== false}
      menuShouldScrollIntoView={true}
      {...restProps}
    />
  );
};
